var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"castWrap"},[(_vm.loading)?_c('div',{staticClass:"castContainer"},[_c('Spinner')],1):_c('div',{staticClass:"castContainer"})])}
var staticRenderFns = []

export { render, staticRenderFns }